module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0047.jpg?v=fd194cd2";